import './App.css';
import About from './pages/About';
import Contact from './pages/Contact';
import Home from './pages/Home';
import { Routes, Route, useLocation } from 'react-router-dom';
import ScheduleDemo from './components/ScheduleDemo';
import Privacy from './components/Privacy';
import Terms from './components/Terms';
import ChatBotWidget from './components/ChatBotWidget.jsx';
import NotFound from './components/NotFound.js';

import Digital from './features/services/Digital';
import Consulting from './features/services/Consulting';
import Technology from './features/services/Technology';
import Product from './pages/Product';
import Service from './pages/Service';
import ScrollTooTop from "./components/ScrollTooTop";
import BfsiSystem from './features/industries/BfsiSystem';
import EducationalSystem from './features/industries/EducationalSystem';
import HealthCare from './features/industries/HealthCare';
import Professional from './features/industries/Professional';
import MolecularScience from './features/industries/MolecularScience.js';
import ClientManage from './features/solutions/ClientManage';
import CoManage from './features/solutions/CoManage';
import VedalyticsManage from './features/solutions/VedalyticsManage';

function App() {
  const location = useLocation();

  const validPaths = [
    '/',
    '/about',
    '/contact',
    '/product',
    '/service',
    '/scheduleDemo',
    '/privacy',
    '/terms',
    '/digital',
    '/consulting',
    '/technology',
    '/bfsi',
    '/education',
    '/healthcare',
    '/professional',
    '/molecular',
    '/clientManage',
    '/coManage',
    '/vedalyticsManage'
  ];

  const isValidPath = validPaths.includes(location.pathname);

  return (
    <div className="App">
      <ScrollTooTop />
      {isValidPath && <ChatBotWidget />}

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/product" element={<Product />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/service" element={<Service />} />
        <Route path='/scheduleDemo' element={<ScheduleDemo />} />
        <Route path='/privacy' element={<Privacy />} />
        <Route path='/terms' element={<Terms />} />

        <Route path='/digital' element={<Digital />} />
        <Route path='/consulting' element={<Consulting />} />
        <Route path='/technology' element={<Technology />} />
        <Route path='/bfsi' element={<BfsiSystem />} />
        <Route path='/education' element={<EducationalSystem />} />
        <Route path='/healthcare' element={<HealthCare />} />
        <Route path='/professional' element={<Professional />} />
        <Route path='/molecular' element={<MolecularScience />} />
        <Route path='/clientManage' element={<ClientManage />} />
        <Route path='/coManage' element={<CoManage />} />
        <Route path='/vedalyticsManage' element={<VedalyticsManage />} />

        {/* Catch-all route for 404 */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </div>
  );
}


export default App;
